import { PopUp, Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { H2 } from '../../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../../constans';
import styles from './styles.module.scss';

const CancelWbExpresPostingPopUp = ({ close = () => { }, clickOk = () => { } }) => {
  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Точно отменит заказ?</H2>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          onClick={clickOk}
        >
          Да
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CancelWbExpresPostingPopUp;
